<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
      <v-row style="background:#fafafa;">
        <v-col cols="12" class="pa-0">
          <v-row class="py-1 px-5">
            <v-col cols="12" md="12" LeadsPannel>
              <v-row>
                <v-col cols="12" LEADSPANEL>
                  <v-card :loading="loading">
                    <v-card-text class="py-0">
                      <v-row class="align-center">
                        <v-col cols="12">
                          <v-row class="align-center">
                            <v-col cols="2" class="text-center" TITLE>
                              <v-icon size="40" color="secondary">style</v-icon>
                            </v-col>
                            <v-col cols="10" TITLE>
                              <div :class="`${arabic?'arFont':'enFont'} black--text`">{{i18n["academy_settings"]}}</div>
                              <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["sections_settings"] }}</div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                          <Paging 
                            :resourceSettings="resourceSettings" 
                            :resource="resource"
                            @loadResource="loadResource"
                            @pageByNumber="pageByNumber"
                            @createResource="dialog = true"
                          />
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-1 my-0`" v-for="(d, i) in resource.data" :key="i+'not'">
                          <v-row class="align-center elevation-2">
                            <v-col cols="3" :class="`${arabic?'arFont':'enFont'}`">
                              <span style="font-size: 12px;">{{ i18n.label }}</span>
                              <div style="font-weight:bold;">{{d.label}}</div>
                            </v-col>
                            <v-col cols="3" :class="`${arabic?'arFont':'enFont'}`">
                              <span style="font-size: 12px;">{{ i18n.menu_label }}</span>
                              <div style="font-weight:bold;">{{d.menu_label}}</div>
                            </v-col>
                            <v-col cols="3" :class="`${arabic?'arFont':'enFont'}`">
                              <span style="font-size: 12px;">{{ i18n.slug }}</span>
                              <div style="font-weight:bold;">{{d.slug}}</div>
                            </v-col>
                            <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                              <v-btn color="blue" text @click="editResource(d)">{{ i18n.edit }}</v-btn>
                            </v-col>
                            <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                              <v-btn color="error" text @click="() => deleteResource(d)">{{ i18n.delete }}</v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  
      <MultiDialog
        :deleting="deleting"
        :dialog="dialog"
        :resourceKeys="resourceKeys"
        :resourceSettings="resourceSettings"
        :newResource="newResource"
        :loading="loading"
        @closeDialog="closeDialog"
        @postResource="postResource"
        @updateResource="updateResource"
        @deleteResource="postDelete"
        @getUpload="getUpload"
      />
    </v-container>
  </template>
  
  <script>
  import Paging from '@/components/Paging'
  import json2csv from 'json2csv'
  import MultiDialog from '@/components/multiDialog.vue';
  
  export default {
    components: { Paging, MultiDialog },
    data() {
      return {
        resourceKeys: [
          { name: 'label', label: 'label', type: 'text', fetched: 'label', required: true, readonly: false },
          { name: 'menu_label', label: 'menu_label', type: 'text', fetched: 'label', required: true, readonly: false },
          { name: 'slug', label: 'slug', type: 'text', fetched: 'slug', required: true, readonly: false },
          { name: 'image', label: 'image', type: 'upload', required: false, readonly: false, info: {en: '', ar: ''} },
        ],
        loading:false,
        dialog:false,
        vresource:[],
        resource:[],
        search:null,
        rules: {
          required: value => !!value || this.i18n['required'],
          email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
        },
        resourceSettings:{
        createResource: true,
          resourceName:'categories',
          search:false,
          create:false,
          pagination:true,
        },
        models:{
          articles: [],
          keywords:[],
          categories: [],
        },
        newResource:{},
        editing:false,
        deleting:false,
        firstPanel:true,
        secondPanel:false,
        thirdPanel:false,
        selectedPanel:'firstPanel',
        subitems:[
          
        ],
        menu1:false,
        fromDate:null,
        menu2:false,
        toDate:null,
        statuses:[],
        selectedStatus:null,
        file:null,
        import_leads:null,
        excludeUsers:[],
        selectedCountries:[],
        filterUsersBy:null,
        products:[],
        selectedProducts:[],
        selectedUsers:[],
        notification:{},
        count:0,
        categories: [],
        keywords: []
      }
    },
    methods: {
      getUpload({field, value})
      {
        this.newResource[field] = value 
      },
      editResource(resource) {
        this.newResource = {...resource}
        this.dialog = true 
      },
      updateLoadingState(is_loading = false) {
        this.loading = is_loading
      },
      closeDialog() {
        this.newResource = {}
        this.articleDialog = false
        this.dialog = false
        this.deleting = false
      },
      filterObject(item, queryText, itemText) {
        let v = Object.values(item).filter(x=>typeof x == 'string')
        let a = false
        v.forEach(x=>{
          if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
        })
        if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
        return a
      },
      clipboardSuccessHandler (){
        this.$emit('snackbarNotification', `Copied`, 'success')
      },
      clipboardErrorHandler () {
        this.$emit('snackbarNotification', `Failed`, 'error')
      },
      async pageByNumber(n){
        return new Promise(async (res, rej)=>{
          this.loading = true
          if(!this.search){
            this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
          } else {
            this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
          }
          this.loading = false
        })
      },
      goTo(path) {
        this.$router.push(path).catch(x=>{})
      },
      buildFilter(){
        let filter = ``
        
        return filter
      },
      async filterLeads(){
        // console.log('filterLeads')
        await this.loadResource()
      },
      async loadResource() {
        return new Promise(async (res, rej)=>{
          this.loading = true
          if(!this.search){
            this.resource = await this.$store.dispatch('getResource', {resource: this.endpoint + '?' + this.buildFilter()})
            console.log(this.resource)
            res()
          } else {
            // console.log('search', this.search)
            this.resource = await this.$store.dispatch('postResource', {resource: this.endpoint + this.buildFilter(), value:{search:this.search}})
            console.log(this.resource)
            res()
          }
  
          this.loading = false
          res()
        })
      },
      exportSimpleData(data, name){
        let a = json2csv.parse(data)
        // console.log(a)
        let csvContent = "data:text/csv;charset=utf-8," 
        var encodedUri =  csvContent + encodeURIComponent(a);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        let n = name ? name : 'failed_export'
        link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
      },
      showPannel(v){
        this[v] = true
        let all = this.subitems.map(x=>x.value)
        all.filter(x=>x!=v).forEach(x=>this[x] = false)
      },
      async postResource(resource = null) {
        this.loading = true;
        const settings = resource ? resource : this.newResource;
  
        await this.$store.dispatch('postResource', {
          resource: this.endpoint,
          value: settings,
        });
  
        await this.loadResource();
  
        this.newResource = {};
        this.dialog = false;
        this.loading = false;
      },
  
      async updateResource(data) {
        return new Promise(async (res, rej) => {
          this.loading = true;

          await this.$store.dispatch('putResource', {
            resource: `${this.endpoint}/${data.id}`,
            value: data,
          });
          
          this.newResource = {};
          this.dialog = false;
          this.loading = false;

          this.loadResource();
          res(true);
        });
      },
      async deleteResource(resource) {
        this.deleting = true
        this.newResource = {...resource}
        this.dialog = true
      },
      async postDelete(resource) {
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:`${this.endpoint}/${resource.id}`}) 
        this.loading = false
        this.dialog = false
        this.newResource = {}
        this.deleting = false
        await this.loadResource()
      },
      details(){
  
      }
    },
    computed:{
      endpoint() {
        return '/help/categories'
      },
      countries(){
        return this.$store.state.countries
      },
      statuses_obj(){
        return this.$store.state.statuses_obj
      },
      api(){
        return this.$store.state.settings.apiBase
      },
      users(){
        let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
        // console.log(sa)
        return this.$store.state.users.filter(x=>{
          if(!sa) {
            return x.superior == this.$store.state.user.level
          } else return x
        })
      },
      site(){
        return this.$store.state.site
      },
      items() {
        return this.$store.state.menu
      },
      superAdmin(){
        return this.$store.state.superAdmin
      },
      isLogin() {
        return this.$store.state.centralLogin
      },
      language(){
        return this.$store.state.language
      },
      globalLoading(){
        return this.$store.state.globalLoading
      },
      user(){
        return this.$store.state.user
      },
      i18n(){
        return this.$store.state.i18n[this.$store.state.language]
      },
      arabic(){
        if(this.$store.state.language == 'ar') return true
      },
      routeTitle(){
        let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
        let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
        if(main.length) {
          return this.$store.state.i18n[this.$store.state.language][main[0].text]
        } else if(sub.length) {
          return this.$store.state.i18n[this.$store.state.language][sub[0].text]
        } else {
          return ''
        }
      },
      roles(){
        return this.$store.state.userRoles
      },
      notifications(){
        return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
      },
    },
    async created(){
      await this.loadResource()
    },
  }
  </script>
  
  <style>
  </style>